import { render, staticRenderFns } from "./BusinessName.vue?vue&type=template&id=0bbe39a8&"
import script from "./BusinessName.vue?vue&type=script&lang=js&"
export * from "./BusinessName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports